<template>
  <section class="mt-7" data-testid="cockpit-ppc-trend-section">
    <h2 class="cockpit-section-title">
      {{ sectionTitle }}
    </h2>

    <div class="flex flex-wrap items-center justify-between gap-3 mb-3">
      <div class="flex items-center gap-2 flex-wrap">
        <button
          v-for="option in levelOptions"
          :key="option.value"
          type="button"
          class="cockpit-pill"
          :class="{ 'cockpit-pill--active': ppcLevel === option.value }"
          :data-testid="`cockpit-ppc-level-${option.value}`"
          @click="$emit('update:ppcLevel', option.value)"
        >
          {{ option.label }}
        </button>
      </div>

      <div class="flex items-center gap-3 flex-wrap">
        <Select
          v-if="ppcLevel === 'team'"
          :model-value="ppcEntityId"
          :options="teams"
          option-label="label"
          option-value="id"
          class="cockpit-select"
          data-testid="cockpit-ppc-team-select"
          @update:model-value="$emit('update:ppcEntityId', $event)"
        />
        <Select
          v-if="ppcLevel === 'person'"
          :model-value="ppcEntityId"
          :options="persons"
          option-label="label"
          option-value="id"
          class="cockpit-select"
          data-testid="cockpit-ppc-person-select"
          @update:model-value="$emit('update:ppcEntityId', $event)"
        />
        <div class="flex items-center gap-2">
          <button
            v-for="option in periodOptions"
            :key="option.value"
            type="button"
            class="cockpit-pill"
            :class="{ 'cockpit-pill--active': ppcPeriod === option.value }"
            :data-testid="`cockpit-ppc-period-${option.value}`"
            @click="$emit('update:ppcPeriod', option.value)"
          >
            {{ option.label }}
          </button>
        </div>
      </div>
    </div>

    <CockpitPpcTrendChart :bars="chartBars" />
  </section>
</template>

<script>
import Select from 'primevue/select';
import CockpitPpcTrendChart from './CockpitPpcTrendChart.vue';

export default {
  name: 'CockpitPpcTrendSection',
  components: { Select, CockpitPpcTrendChart },
  props: {
    ppcLevel: { type: String, default: 'project' },
    ppcPeriod: { type: String, default: 'week' },
    ppcEntityId: { type: String, default: '' },
    teams: { type: Array, default: () => [] },
    persons: { type: Array, default: () => [] },
    chartBars: { type: Array, default: () => [] },
  },
  emits: ['update:ppcLevel', 'update:ppcPeriod', 'update:ppcEntityId'],
  computed: {
    sectionTitle() {
      return this.ppcPeriod === 'month'
        ? this.$t('UserProjects.cockpit.sections.ppcTrendMonths')
        : this.$t('UserProjects.cockpit.sections.ppcTrendWeeks');
    },
    levelOptions() {
      return [
        { value: 'project', label: this.$t('UserProjects.cockpit.levels.project') },
        { value: 'team', label: this.$t('UserProjects.cockpit.levels.team') },
        { value: 'person', label: this.$t('UserProjects.cockpit.levels.person') },
      ];
    },
    periodOptions() {
      return [
        { value: 'week', label: this.$t('UserProjects.cockpit.periods.weeks') },
        { value: 'month', label: this.$t('UserProjects.cockpit.periods.months') },
      ];
    },
  },
};
</script>

<style scoped>
.cockpit-section-title {
  margin: 0 0 0.75rem;
  font-size: 13px;
  color: #ababab;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  font-weight: 500;
}

.cockpit-pill {
  padding: 0.375rem 0.875rem;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 500;
  border: none;
  background: #f5f5f5;
  color: #6b6b6b;
  cursor: pointer;
}

.cockpit-pill--active {
  background: var(--accent-gradient, linear-gradient(135deg, #c83a77, #e44b55, #e4821a));
  color: #fff;
}

.cockpit-select {
  min-width: 10rem;
}
</style>
